import { SearchSurgicalOrdersNew } from 'domain/usecases/surgical-order/search-surgical-orders-new'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteSearchSurgicalOrdersNew implements SearchSurgicalOrdersNew {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  load(
    params: SearchSurgicalOrdersNew.Params
  ): Promise<SearchSurgicalOrdersNew.Model> {
    return this.surgicalOrderRepository.searchSurgicalOrdersNew(params)
  }
}

export type SearchSurgicalOrdersModelNew = SearchSurgicalOrdersNew.Model
